<template>
	<div>
		<!-- <div class="surebox" :style="{'align-items':top?'flex-start':''}">
			<div class="sl" :style="{'width':width}">
				<span v-if="star">*</span>{{text}} :
			</div>
			<div class="sr">
				<slot></slot>
			</div>
		</div> -->
		11111111111111111111111111111
	</div>
</template>

<script>
	export default {
		name: 'copyright',
		components: {},
		props: {
			text: {
				default: '',
				type: String
			},
			star: {
				type: Boolean,
				default: false
			},
			top: {
				type: Boolean,
				default: false
			},
			width: {
				type: String,
				default: '120px'
			}
		},
		data() {
			return {}
		},
		methods: {

		}
	}
</script>

<style lang="scss" scoped>
	.surebox {
		display: flex;
		margin-top: 20px;


		.sl {
			display: flex;
			align-items: center;

			span {
				width: 4px;
				display: inline-block;
				height: 4px;
				color: var(--brand);
				margin-right: 6px;
				line-height: 10px;
				font-size: 16px;
			}
		}

		.sr {
			margin-left: 10px;
			flex: 1;
			color: var(--info);

			.el-image {
				width: 140px;
				border-radius: 4px;
			}
		}
	}
</style>
